module.exports = __webpack_public_path__ + "static/media/cat-13.119df66a.jpg";